import { render } from "./BarcodeScanner.vue?vue&type=template&id=6bdc08e9&scoped=true&ts=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=ts"
export * from "./BarcodeScanner.vue?vue&type=script&lang=ts"

import "./BarcodeScanner.vue?vue&type=style&index=0&id=6bdc08e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdc08e9"]])

export default __exports__